import { useState, useEffect, useCallback } from 'react';
import { taskService } from '../services/taskService';

/**
 * Hook to manage project tasks: fetching and loading states.
 * Polinaidu: 24-04-2026 (17:15) - Standardized task management with custom hook
 */
export const useProjectTasks = (projectId) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTasks = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await taskService.getProjectTasks(projectId);
      const sorted = (data || []).sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
      setTasks(sorted);
    } catch (err) {
      console.error('[useProjectTasks] fetch failed:', err);
      setError(err?.message || 'Failed to load tasks');
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return {
    tasks,
    loading,
    error,
    refreshTasks: fetchTasks
  };
};
